import { injectable } from 'inversify'

@injectable()
class Environment {
    get oAuthDomain(): string {
        return process.env.OAUTH_DOMAIN ?? ''
    }

    get oAuthClientId(): string {
        return process.env.OAUTH_CLIENT_ID ?? ''
    }

    get oAuthAudience(): string {
        return process.env.OAUTH_AUDIENCE ?? ''
    }

    get oAuthRedirectPath(): string {
        return process.env.OAUTH_LOGIN_REDIRECT_PATH ?? ''
    }

    get oAuthLogoutPath(): string {
        return process.env.OAUTH_LOGOUT_REDIRECT_PATH ?? ''
    }

    get serviceUrl(): string {
        return process.env.REACT_APP_SERVICE_URL || ''
    }

    get enablePlayground(): boolean {
        return process.env.REACT_APP_ENABLE_PLAYGROUND?.toLocaleLowerCase() === 'true'
    }

    get userGuideUrl(): string {
        return process.env.USER_GUIDE_URL || ''
    }

    get launchFirehoseIntegration(): string {
        return process.env.FIREHOSE_INTEGRATION_TEMPLATE || ''
    }

    get launchKinesisIntegration(): string {
        return process.env.KIBSI_INTEGRATION_TEMPLATE || ''
    }
}

export { Environment }
